<template>
<div>
    <Carousel v-if="dataList.length>1"
        v-model="valueKey"
        :autoplay="setting.autoplay"
        :autoplay-speed="setting.autoplaySpeed"
        :dots="setting.dots"
        :radius-dot="setting.radiusDot"
        :trigger="setting.trigger"
        :arrow="setting.arrow"
        :loop="setting.loop">
        <CarouselItem  v-for="(item,index) in dataList" :key="index">
            <div @click='advertClick(item)' class="demo-carousel" v-html="item.content">
            </div>
        </CarouselItem>
    </Carousel>
    <div v-else v-for="(item,index) in dataList" :key="index">
        <div @click='advertClick(item)' class="demo-carousel" v-html="item.content"></div>
    </div>
</div>
</template>
<script>
    export default {
        name:"ihlpCarousel",
        props: {
            value: {
                type: [String, Array],
                default: ''
            },
            dataList:{
                type: [String, Array],
                default: ''
            },
            cfg:{
                type: Object,
                default: ''
            },
            onClick:{
                type: Function
            },
        },
        data () {
            return {
                valueKey: 0,
                setting: {
                    loop:false,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    dots: 'inside',
                    radiusDot: false,
                    trigger: 'click',
                    // arrow: 'hover'
                    arrow:'never'
                }
            }
        },
        created(){
            this.$utils.getFormAttrValue(this.setting,this.cfg)
        },
        watch: { 
            cfg(newValue,oldValue){
                this.$utils.getFormAttrValue(this.setting,newValue)
            }
        },
        methods:{
            advertClick(item){
                this.$emit('onClick',item)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/common/carousel/carousel.vue